import { render } from "./Font.vue?vue&type=template&id=37bbb6e3"
import script from "./Font.vue?vue&type=script&lang=ts"
export * from "./Font.vue?vue&type=script&lang=ts"
script.render = render

export default script